import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a225e09"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "address-modal-panel relative ml-auto h-full bg-white flex flex-col w-full sm:w-[480px] shadow-2xl" }
const _hoisted_2 = { class: "flex items-center gap-3 px-4 py-4 border-b border-gray-100 shrink-0" }
const _hoisted_3 = {
  viewBox: "0 0 24 24",
  style: {"width":"1.4rem","height":"1.4rem"}
}
const _hoisted_4 = {
  key: 0,
  fill: "currentColor",
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
}
const _hoisted_5 = {
  key: 1,
  fill: "currentColor",
  d: "M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z"
}
const _hoisted_6 = { class: "text-sm font-bold uppercase tracking-wider flex-1" }
const _hoisted_7 = { class: "flex flex-col flex-1 min-h-0" }
const _hoisted_8 = { class: "px-4 pt-3 pb-2 shrink-0" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "absolute left-3 top-1/2 -translate-y-1/2 text-gray-400",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "11",
    cy: "11",
    r: "7",
    stroke: "currentColor",
    "stroke-width": "1.8"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21 21l-4.35-4.35",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6 6l12 12M6 18L18 6",
    stroke: "#6b7280",
    "stroke-width": "2",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12 2v3M12 19v3M2 12h3M19 12h3",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "6",
  stroke: "currentColor",
  "stroke-width": "1.8"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "2",
  fill: "currentColor"
}, null, -1))
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "animate-spin",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "9",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-opacity": "0.25"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M21 12a9 9 0 0 0-9-9",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "flex-1" }
const _hoisted_24 = {
  class: "text-sm font-bold",
  style: {"color":"var(--primary-color, #ef4444)"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500 mt-0.5" }, "Detectaremos seu endereço pelo GPS", -1))
const _hoisted_26 = {
  key: 0,
  class: "px-4 pb-1"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-[11px] font-bold uppercase tracking-wider text-gray-500 mt-3 mb-2" }, "Endereços salvos", -1))
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center shrink-0 mt-0.5" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12 13.43a3.12 3.12 0 1 0 0-6.24 3.12 3.12 0 0 0 0 6.24z",
      stroke: "#737373",
      "stroke-width": "1.5"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M3.62 8.49C5.59-.16 18.42-.15 20.38 8.5c1.15 5.07-2 9.36-4.77 12.01a5.2 5.2 0 0 1-7.22 0C5.62 17.85 2.47 13.56 3.62 8.49z",
      stroke: "#737373",
      "stroke-width": "1.5"
    })
  ])
], -1))
const _hoisted_30 = { class: "flex-1 min-w-0" }
const _hoisted_31 = { class: "text-sm font-semibold truncate" }
const _hoisted_32 = { class: "text-xs text-gray-500 truncate" }
const _hoisted_33 = { class: "flex-1 overflow-y-auto px-4 pb-4" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-[11px] font-bold uppercase tracking-wider text-gray-500 mt-3 mb-1" }, "Resultados", -1))
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center shrink-0 mt-0.5" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12 13.43a3.12 3.12 0 1 0 0-6.24 3.12 3.12 0 0 0 0 6.24z",
      stroke: "#737373",
      "stroke-width": "1.5"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M3.62 8.49C5.59-.16 18.42-.15 20.38 8.5c1.15 5.07-2 9.36-4.77 12.01a5.2 5.2 0 0 1-7.22 0C5.62 17.85 2.47 13.56 3.62 8.49z",
      stroke: "#737373",
      "stroke-width": "1.5"
    })
  ])
], -1))
const _hoisted_37 = { class: "flex-1 min-w-0" }
const _hoisted_38 = { class: "text-sm font-semibold truncate" }
const _hoisted_39 = { class: "text-xs text-gray-500 truncate" }
const _hoisted_40 = {
  key: 1,
  class: "py-10 flex flex-col items-center justify-center text-gray-400"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "animate-spin mb-2",
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "9",
    stroke: "currentColor",
    "stroke-width": "2.5",
    "stroke-opacity": "0.25"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21 12a9 9 0 0 0-9-9",
    stroke: "currentColor",
    "stroke-width": "2.5",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "Buscando endereços...", -1))
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = {
  key: 2,
  class: "py-10 text-center"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Nenhum endereço encontrado", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-400 mt-1" }, "Tente refinar o termo da busca", -1))
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = {
  key: 3,
  class: "py-10 text-center"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-14 h-14 mx-auto rounded-full bg-gray-50 flex items-center justify-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "11",
      cy: "11",
      r: "7",
      stroke: "#9ca3af",
      "stroke-width": "1.5"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M21 21l-4.35-4.35",
      stroke: "#9ca3af",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    })
  ])
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500 font-medium" }, "Comece a digitar seu endereço", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-400 mt-1 max-w-[260px] mx-auto" }, "Ou use sua localização atual para preenchimento automático", -1))
const _hoisted_52 = [
  _hoisted_49,
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = {
  key: 4,
  class: "py-6 text-center"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-400" }, "Digite ao menos 3 caracteres", -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = { class: "px-4 pb-4 pt-2 border-t border-gray-100 shrink-0" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "underline" }, "Digitar endereço manualmente", -1))
const _hoisted_58 = { class: "flex flex-col flex-1 min-h-0" }
const _hoisted_59 = { class: "relative shrink-0" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute inset-0 flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "relative -mt-6" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "40",
      height: "48",
      viewBox: "0 0 40 48",
      fill: "none"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M20 0C8.95 0 0 8.95 0 20c0 14 20 28 20 28s20-14 20-28C40 8.95 31.05 0 20 0z",
        fill: "var(--primary-color, #ef4444)"
      }),
      /*#__PURE__*/_createElementVNode("circle", {
        cx: "20",
        cy: "20",
        r: "6.5",
        fill: "#fff"
      })
    ])
  ])
], -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 2v3M12 19v3M2 12h3M19 12h3",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "6",
    stroke: "currentColor",
    "stroke-width": "1.8"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "2",
    fill: "currentColor"
  })
], -1))
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = { class: "flex-1 overflow-y-auto px-4 py-4 space-y-4" }
const _hoisted_64 = { class: "flex items-start gap-3" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 13.43a3.12 3.12 0 1 0 0-6.24 3.12 3.12 0 0 0 0 6.24z",
    stroke: "currentColor",
    "stroke-width": "1.5"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3.62 8.49C5.59-.16 18.42-.15 20.38 8.5c1.15 5.07-2 9.36-4.77 12.01a5.2 5.2 0 0 1-7.22 0C5.62 17.85 2.47 13.56 3.62 8.49z",
    stroke: "currentColor",
    "stroke-width": "1.5"
  })
], -1))
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = { class: "flex-1 min-w-0" }
const _hoisted_68 = { class: "text-sm font-bold leading-tight" }
const _hoisted_69 = {
  key: 0,
  class: "text-xs text-gray-500 mt-1"
}
const _hoisted_70 = { class: "space-y-2 pt-1" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-[11px] font-bold uppercase tracking-wider text-gray-500" }, "Detalhes", -1))
const _hoisted_72 = { class: "grid grid-cols-3 gap-2" }
const _hoisted_73 = { class: "px-4 py-3 border-t border-gray-100 shrink-0 cart-footer" }
const _hoisted_74 = ["disabled"]

import { ref, computed, watch, nextTick, onBeforeUnmount } from 'vue'
import { useToast } from 'vue-toastification'
import { loadLeaflet, photonSearch, photonReverse, parsePhotonAddress, ParsedAddress, PhotonSuggestion } from '@/composables/useLeafletMap'
import { restaurant } from '@/global/state/GlobalState'


export default /*#__PURE__*/_defineComponent({
  __name: 'AddressSearchModal',
  props: {
    isOpen: { type: Boolean, required: true },
    savedAddresses: { type: Array, default: () => [] }
},
  emits: ['close', 'select', 'manual'],
  setup(__props, { emit: __emit }) {

const primaryColor = computed(() => (restaurant.value as any)?.restaurantDesignCustom?.primaryColor || '#ef4444')

/* global defineProps, defineEmits */
// eslint-disable-next-line no-undef
const props = __props

// eslint-disable-next-line no-undef
const emit = __emit

const toast = useToast()

const step = ref<'search' | 'confirm'>('search')
const query = ref('')
const searching = ref(false)
const loadingLocation = ref(false)
const suggestions = ref<PhotonSuggestion[]>([])

const searchInputEl = ref<HTMLInputElement | null>(null)
const mapEl = ref<HTMLDivElement | null>(null)

const selectedLat = ref<number | null>(null)
const selectedLng = ref<number | null>(null)
const selected = ref<ParsedAddress | null>(null)

const formNumber = ref('')
const formComplement = ref('')
const formReference = ref('')
const formNeighborhood = ref('')

let map: any = null
let mapMoveTimer: any = null
let mapIdleListener: any = null
let debounceTimer: any = null
let lastReverseAt: { lat: number; lng: number } | null = null

const headlineAddress = computed(() => {
    if (!selected.value) return ''
    if (selected.value.street) {
        return selected.value.number
            ? `${selected.value.street}, ${selected.value.number}`
            : selected.value.street
    }
    return selected.value.formatted || 'Local selecionado'
})

const secondaryAddress = computed(() => {
    if (!selected.value) return ''
    const parts: string[] = []
    if (formNeighborhood.value || selected.value.neighborhood) parts.push(formNeighborhood.value || selected.value.neighborhood)
    if (selected.value.city) parts.push(selected.value.city)
    if (selected.value.state) parts.push(selected.value.state)
    return parts.join(' · ')
})

const canConfirm = computed(() => {
    return Boolean(selected.value?.street) && formNumber.value.trim().length > 0 && (formNeighborhood.value.trim().length > 0 || (selected.value?.neighborhood || '').length > 0)
})

watch(() => props.isOpen, async (open) => {
    if (open) {
        step.value = 'search'
        query.value = ''
        suggestions.value = []
        selected.value = null
        selectedLat.value = null
        selectedLng.value = null
        formNumber.value = ''
        formComplement.value = ''
        formReference.value = ''
        formNeighborhood.value = ''
        document.body.style.overflow = 'hidden'
        try {
            await loadLeaflet()
        } catch (e) {
            console.warn('[address] Leaflet failed to load', e)
            toast.error('Não foi possível carregar o mapa')
        }
        await nextTick()
        searchInputEl.value?.focus()
    } else {
        document.body.style.overflow = ''
        destroyMap()
    }
})

onBeforeUnmount(() => {
    document.body.style.overflow = ''
    destroyMap()
    if (debounceTimer) clearTimeout(debounceTimer)
    if (mapMoveTimer) clearTimeout(mapMoveTimer)
})

function close() { emit('close') }

function onBack() {
    if (step.value === 'confirm') {
        step.value = 'search'
        destroyMap()
        nextTick(() => searchInputEl.value?.focus())
    } else {
        close()
    }
}

function clearQuery() {
    query.value = ''
    suggestions.value = []
    searching.value = false
    searchInputEl.value?.focus()
}

function onQueryInput() {
    if (debounceTimer) clearTimeout(debounceTimer)
    if (!query.value || query.value.length < 3) {
        suggestions.value = []
        searching.value = false
        return
    }
    searching.value = true
    debounceTimer = setTimeout(runSearch, 300)
}

async function runSearch() {
    try {
        suggestions.value = await photonSearch(query.value, { lang: 'default', limit: 8 })
    } catch (e) {
        console.warn('[address] photon search failed', e)
        suggestions.value = []
    } finally {
        searching.value = false
    }
}

function selectSuggestion(s: PhotonSuggestion) {
    const parsed = parsePhotonAddress(s.feature)
    selected.value = parsed
    selectedLat.value = parsed.lat
    selectedLng.value = parsed.lng
    formNumber.value = parsed.number || ''
    formNeighborhood.value = parsed.neighborhood || ''
    goToConfirmStep()
}

function useSavedAddress(addr: any) {
    const parsed: ParsedAddress = {
        street: addr.street || '',
        number: addr.number || '',
        neighborhood: addr.neighborhood || '',
        city: addr.city || '',
        state: addr.state || '',
        zipCode: addr.zipCode || '',
        country: addr.country || 'BR',
        formatted: [addr.street, addr.number, addr.neighborhood, addr.city, addr.state].filter(Boolean).join(', '),
        lat: addr.lat ?? null,
        lng: addr.lng ?? null
    }
    selected.value = parsed
    selectedLat.value = parsed.lat
    selectedLng.value = parsed.lng
    formNumber.value = parsed.number
    formComplement.value = addr.complement || ''
    formReference.value = addr.reference || ''
    formNeighborhood.value = parsed.neighborhood
    if (parsed.lat && parsed.lng) {
        goToConfirmStep()
    } else {
        emit('select', { ...parsed, number: formNumber.value, complement: formComplement.value, reference: formReference.value })
    }
}

function useCurrentLocation() {
    if (!('geolocation' in navigator)) {
        toast.warning('Geolocalização não disponível neste navegador')
        return
    }
    loadingLocation.value = true
    navigator.geolocation.getCurrentPosition(
        async (pos) => {
            const { latitude, longitude } = pos.coords
            await reverseGeocode(latitude, longitude, true)
            loadingLocation.value = false
        },
        (err) => {
            loadingLocation.value = false
            const msg = err.code === err.PERMISSION_DENIED
                ? 'Permissão de localização negada. Habilite para usar este recurso.'
                : 'Não foi possível obter sua localização'
            toast.warning(msg, { timeout: 3000 })
        },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
    )
}

async function reverseGeocode(lat: number, lng: number, advance = false) {
    try {
        const s = await photonReverse(lat, lng)
        if (s) {
            const parsed = parsePhotonAddress(s.feature)
            // Keep user-typed number if exists; otherwise use photon's
            const previousNumber = formNumber.value
            selected.value = { ...parsed, lat, lng }
            selectedLat.value = lat
            selectedLng.value = lng
            if (!previousNumber) formNumber.value = parsed.number || ''
            if (!formNeighborhood.value) formNeighborhood.value = parsed.neighborhood || ''
            if (advance) goToConfirmStep()
        } else if (advance) {
            // Even without a reverse hit, advance with empty address
            selected.value = {
                street: '', number: '', neighborhood: '', city: '', state: '', zipCode: '',
                country: 'BR', formatted: 'Local selecionado', lat, lng
            }
            selectedLat.value = lat
            selectedLng.value = lng
            goToConfirmStep()
        }
    } catch (e) {
        if (advance) toast.warning('Não foi possível identificar o endereço neste local')
    }
}

async function goToConfirmStep() {
    step.value = 'confirm'
    await nextTick()
    initMap()
}

function initMap() {
    if (!window.L || !mapEl.value || selectedLat.value === null || selectedLng.value === null) return

    const L = window.L
    const center: [number, number] = [selectedLat.value, selectedLng.value]

    if (map) {
        map.remove()
        map = null
    }

    map = L.map(mapEl.value, {
        center,
        zoom: 17,
        zoomControl: true,
        scrollWheelZoom: true,
        attributionControl: false
    })

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; OpenStreetMap'
    }).addTo(map)

    // small attribution control at bottom-right
    L.control.attribution({ position: 'bottomright', prefix: false }).addAttribution('&copy; OpenStreetMap').addTo(map)

    if (mapIdleListener) map.off('moveend', mapIdleListener)
    mapIdleListener = () => {
        if (mapMoveTimer) clearTimeout(mapMoveTimer)
        mapMoveTimer = setTimeout(onMapIdle, 500)
    }
    map.on('moveend', mapIdleListener)
    lastReverseAt = { lat: center[0], lng: center[1] }
}

function onMapIdle() {
    if (!map) return
    const c = map.getCenter()
    const lat = c.lat
    const lng = c.lng
    if (lastReverseAt) {
        const dLat = Math.abs(lat - lastReverseAt.lat)
        const dLng = Math.abs(lng - lastReverseAt.lng)
        // ~10 meters; below this, skip
        if (dLat < 0.00009 && dLng < 0.00009) return
    }
    lastReverseAt = { lat, lng }
    reverseGeocode(lat, lng, false)
}

function recenterMap() {
    if (!map || selectedLat.value === null || selectedLng.value === null) return
    map.setView([selectedLat.value, selectedLng.value], 17)
}

function destroyMap() {
    if (map) {
        try { map.remove() } catch { /* noop */ }
        map = null
    }
    if (mapMoveTimer) {
        clearTimeout(mapMoveTimer)
        mapMoveTimer = null
    }
    mapIdleListener = null
}

function confirm() {
    if (!selected.value || !canConfirm.value) return
    emit('select', {
        ...selected.value,
        neighborhood: formNeighborhood.value.trim() || selected.value.neighborhood,
        number: formNumber.value.trim(),
        complement: formComplement.value.trim(),
        reference: formReference.value.trim()
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "address-modal" }, {
      default: _withCtx(() => [
        (__props.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "address-modal-wrapper fixed inset-0 z-[200] flex font-inter",
              style: _normalizeStyle(`--primary-color: ${primaryColor.value}`)
            }, [
              _createElementVNode("div", {
                class: "absolute inset-0 bg-black/60",
                onClick: close
              }),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                  _createElementVNode("button", {
                    onClick: onBack,
                    class: "p-1 -ml-1 hover:opacity-60 transition",
                    "aria-label": "Voltar"
                  }, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_3, [
                      (step.value === 'search')
                        ? (_openBlock(), _createElementBlock("path", _hoisted_4))
                        : (_openBlock(), _createElementBlock("path", _hoisted_5))
                    ]))
                  ]),
                  _createElementVNode("h2", _hoisted_6, _toDisplayString(step.value === 'search' ? 'Buscar endereço' : 'Confirmar local'), 1)
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _withDirectives(_createElementVNode("input", {
                        ref_key: "searchInputEl",
                        ref: searchInputEl,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
                        onInput: onQueryInput,
                        type: "text",
                        placeholder: "Digite o endereço, rua, número...",
                        autocomplete: "off",
                        spellcheck: "false",
                        class: "w-full bg-gray-50 border border-gray-100 rounded-xl pl-10 pr-10 py-3 text-sm focus:outline-none focus:border-gray-400 focus:bg-white transition"
                      }, null, 544), [
                        [_vModelText, query.value]
                      ]),
                      (query.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: clearQuery,
                            class: "absolute right-2 top-1/2 -translate-y-1/2 w-7 h-7 flex items-center justify-center rounded-full hover:bg-gray-100",
                            "aria-label": "Limpar"
                          }, _hoisted_12))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("button", {
                    onClick: useCurrentLocation,
                    disabled: loadingLocation.value,
                    class: "mx-4 mt-1 mb-2 flex items-center gap-3 p-3 rounded-xl border-2 border-dashed border-gray-200 hover:border-gray-300 hover:bg-gray-50 transition text-left disabled:opacity-60"
                  }, [
                    _createElementVNode("div", {
                      class: "w-10 h-10 rounded-full flex items-center justify-center shrink-0",
                      style: _normalizeStyle({ background: 'color-mix(in srgb, var(--primary-color, #ef4444) 12%, transparent)', color: 'var(--primary-color, #ef4444)' })
                    }, [
                      (!loadingLocation.value)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_18))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_19, _hoisted_22))
                    ], 4),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("p", _hoisted_24, _toDisplayString(loadingLocation.value ? 'Localizando...' : 'Usar minha localização atual'), 1),
                      _hoisted_25
                    ])
                  ], 8, _hoisted_13),
                  (__props.savedAddresses?.length && !query.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _hoisted_27,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.savedAddresses, (addr, idx) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: idx,
                            onClick: ($event: any) => (useSavedAddress(addr)),
                            class: "w-full flex items-start gap-3 py-3 border-b border-gray-50 last:border-b-0 text-left hover:bg-gray-50 -mx-1 px-1 rounded-lg transition"
                          }, [
                            _hoisted_29,
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("p", _hoisted_31, _toDisplayString((addr as any).street) + ", " + _toDisplayString((addr as any).number), 1),
                              _createElementVNode("p", _hoisted_32, _toDisplayString((addr as any).neighborhood) + " · " + _toDisplayString((addr as any).city) + "/" + _toDisplayString((addr as any).state), 1)
                            ])
                          ], 8, _hoisted_28))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_33, [
                    (suggestions.value.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_34,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestions.value, (s, idx) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: idx,
                              onClick: ($event: any) => (selectSuggestion(s)),
                              class: "w-full flex items-start gap-3 py-3 border-b border-gray-50 last:border-b-0 text-left hover:bg-gray-50 -mx-1 px-1 rounded-lg transition"
                            }, [
                              _hoisted_36,
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("p", _hoisted_38, _toDisplayString(s.main), 1),
                                _createElementVNode("p", _hoisted_39, _toDisplayString(s.secondary), 1)
                              ])
                            ], 8, _hoisted_35))
                          }), 128))
                        ], 64))
                      : (searching.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_43))
                        : (query.value && query.value.length >= 3)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_47))
                          : (!query.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, _hoisted_52))
                            : (_openBlock(), _createElementBlock("div", _hoisted_53, _hoisted_55))
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('manual'))),
                      class: "w-full text-sm font-semibold text-gray-600 hover:text-gray-900 transition py-2"
                    }, [
                      _createTextVNode(" Não encontrou? "),
                      _hoisted_57
                    ])
                  ])
                ], 512), [
                  [_vShow, step.value === 'search']
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", {
                      ref_key: "mapEl",
                      ref: mapEl,
                      class: "w-full h-[260px] bg-gray-100"
                    }, null, 512),
                    _hoisted_60,
                    (selectedLat.value !== null)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: recenterMap,
                          class: "absolute right-3 top-3 w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center hover:bg-gray-50 z-[5]",
                          "aria-label": "Recentralizar"
                        }, _hoisted_62))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", {
                        class: "w-10 h-10 rounded-full flex items-center justify-center shrink-0 mt-0.5",
                        style: _normalizeStyle({ background: 'color-mix(in srgb, var(--primary-color, #ef4444) 12%, transparent)', color: 'var(--primary-color, #ef4444)' })
                      }, _hoisted_66, 4),
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("p", _hoisted_68, _toDisplayString(headlineAddress.value), 1),
                        (secondaryAddress.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_69, _toDisplayString(secondaryAddress.value), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _hoisted_71,
                      _createElementVNode("div", _hoisted_72, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formNumber).value = $event)),
                          type: "text",
                          placeholder: "Nº",
                          inputmode: "numeric",
                          class: "col-span-1 bg-gray-50 p-3 rounded-lg text-sm border border-gray-100 focus:outline-none focus:border-gray-400 focus:bg-white"
                        }, null, 512), [
                          [_vModelText, formNumber.value]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formComplement).value = $event)),
                          type: "text",
                          placeholder: "Complemento (apto, bloco)",
                          class: "col-span-2 bg-gray-50 p-3 rounded-lg text-sm border border-gray-100 focus:outline-none focus:border-gray-400 focus:bg-white"
                        }, null, 512), [
                          [_vModelText, formComplement.value]
                        ])
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formNeighborhood).value = $event)),
                        type: "text",
                        placeholder: "Bairro",
                        class: "w-full bg-gray-50 p-3 rounded-lg text-sm border border-gray-100 focus:outline-none focus:border-gray-400 focus:bg-white"
                      }, null, 512), [
                        [_vModelText, formNeighborhood.value]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formReference).value = $event)),
                        type: "text",
                        placeholder: "Ponto de referência (opcional)",
                        class: "w-full bg-gray-50 p-3 rounded-lg text-sm border border-gray-100 focus:outline-none focus:border-gray-400 focus:bg-white"
                      }, null, 512), [
                        [_vModelText, formReference.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("button", {
                      onClick: confirm,
                      disabled: !canConfirm.value,
                      class: _normalizeClass(["w-full py-4 rounded-xl font-bold text-base flex items-center justify-center gap-2 transition", canConfirm.value ? 'text-white shadow-lg' : 'bg-gray-100 text-gray-400 cursor-not-allowed']),
                      style: _normalizeStyle(canConfirm.value ? { background: 'var(--primary-color, #ef4444)' } : {})
                    }, " Confirmar endereço ", 14, _hoisted_74)
                  ])
                ], 512), [
                  [_vShow, step.value === 'confirm']
                ])
              ])
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})